import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { css } from 'aphrodite';
import { Uploader } from '@citrite/sf-api';
import { EmptyUploadIcon, PageTitle } from '@sharefiledev/flow-web';
import { getCanDrag, t } from '../../util';
import { styles } from './DragAndDrop.styles';
import { withFileDragListener } from './withFileDragListener';
var _DragAndDrop = /*#__PURE__*/function (_React$Component) {
  function _DragAndDrop() {
    var _this;
    _classCallCheck(this, _DragAndDrop);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, _DragAndDrop, [].concat(args));
    _defineProperty(_this, "onDrop", function (event) {
      if (event.dataTransfer.files.length === 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      Uploader.parseItems(event.dataTransfer).then(function (items) {
        _this.props.onItemsSelected(items);
        _this.props.onFilesDropped();
      });
    });
    return _this;
  }
  _inherits(_DragAndDrop, _React$Component);
  return _createClass(_DragAndDrop, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        onDrop: getCanDrag() ? this.onDrop : undefined,
        className: css(styles.dragArea, this.props.scopedOverlay && styles.scopedOverlay, this.props.isDraggingFiles && styles.showDragArea)
      }, /*#__PURE__*/React.createElement(EmptyUploadIcon, {
        size: this.props.scopedOverlay ? 100 : 200
      }), /*#__PURE__*/React.createElement(PageTitle, {
        textAlign: "center"
      }, t('citrix-files-ui:upload.drop_files_here')));
    }
  }]);
}(React.Component);
export var DragAndDrop = withFileDragListener(_DragAndDrop);